import type { ReactNode } from 'react';

import { COOKIE_POLICY } from 'constants/__generated__/routes';

export const LinkToCookiePolicy = (...s: ReactNode[]): ReactNode => {
  return <a href={COOKIE_POLICY}>{s}</a>;
};
